import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentTime } from '../../../../common/helper'
import { changeCriteria, selectCriteria } from '../../../store/slice'
import { TextAreaItem } from './TextAreaItem'

export const TextArea = ({ isNumber, criteriaGroup, screeningIndicatorId }) => {
  const dispatch = useDispatch()

  const conditionIdsStr = useSelector(
    selectCriteria([criteriaGroup, screeningIndicatorId, 'data'], (data) => {
      let ids = []
      if (data) {
        ids = Object.keys(data).filter((key) => !!data[key])
      }
      return JSON.stringify(ids)
    }),
  )
  const conditionIds = JSON.parse(conditionIdsStr)

  //Set default data if not exist
  useEffect(() => {
    if (conditionIds.length === 0) {
      const id = getCurrentTime()
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'data', id],
          data: { id, value: '' },
        }),
      )
    }
  }, [conditionIds])

  const renderContent = () => {
    return conditionIds.map((id, index) => (
      <TextAreaItem
        key={id}
        criteriaGroup={criteriaGroup}
        screeningIndicatorId={screeningIndicatorId}
        conditionId={id}
        hasAddBtn={index === conditionIds.length - 1}
        conditionsLength={conditionIds.length}
        isNumber={isNumber}
      />
    ))
  }

  return <>{renderContent()}</>
}
